import React, { useRef, useState } from 'react';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import CurrencyFormat from 'react-currency-format';
import emailjs from '@emailjs/browser';

const regSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup
    .string()
    .email('Must be a valid email address')
    .required('Email is required'),
  phone: yup.string().required('Phone Number is required'),
  message: yup.string().required('Message is required'),
});

const toastOptions = {
  position: 'bottom-center',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'dark',
};

const ContactForm = () => {
  const form = useRef();
  const [submitting, setSubmitting] = useState(false);

  const sendEmail = async e => {
    e.preventDefault();

    const isValid = await regSchema.isValid({
      name: form.current.name.value,
      email: form.current.email.value,
      phone: form.current.phone.value,
      message: form.current.message.value,
    });

    if (!isValid) {
      toast.error('All fields are mandatory.', toastOptions);
      return;
    }

    const templateParams = {
      from_name: form.current.name.value,
      reply_to: form.current.email.value,
      phone_number: form.current.phone.value,
      message: form.current.message.value,
      to_name: 'YDS Chicago',
    };

    setSubmitting(true);

    emailjs
      .send(
        'service_olm2h8j',
        'template_mjxsh9t',
        templateParams,
        'ykkTnkBKTB6LGN7d_'
      )
      .then(
        result => {
          console.log(result.text);
          toast.success('Message sent successfully', toastOptions);
          form.current.reset();
          setSubmitting(false);
        },
        error => {
          toast.error('Failed to send message', toastOptions);
          setSubmitting(false);
        }
      );
  };

  return (
    <>
      <form onSubmit={sendEmail} ref={form}>
        <div className='relative w-full mb-3 mt-8'>
          <label
            className='block text-gray-700 text-xs font-bold mb-2'
            htmlFor='full-name'
          >
            Full Name
          </label>
          <input
            disabled={submitting}
            name='name'
            type='text'
            className='px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150'
            placeholder='Full Name'
          />
        </div>

        <div className='relative w-full mb-3'>
          <label
            className='block text-gray-700 text-xs font-bold mb-2'
            htmlFor='email'
          >
            Email
          </label>
          <input
            disabled={submitting}
            name='email'
            type='email'
            className='px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150'
            placeholder='Email'
          />
        </div>

        <div className='relative w-full mb-3 mt-3'>
          <label
            className='block text-gray-700 text-xs font-bold mb-2'
            htmlFor='phone'
          >
            Phone Number
          </label>
          <CurrencyFormat
            disabled={submitting}
            name='phone'
            format='+1 (###) ###-####'
            mask='_'
            placeholder='Phone Number'
            className='px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150'
          />
        </div>

        <div className='relative w-full mb-3'>
          <label
            className='block text-gray-700 text-xs font-bold mb-2'
            htmlFor='message'
          >
            Message
          </label>
          <textarea
            disabled={submitting}
            rows='4'
            cols='80'
            name='message'
            className='px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full'
            placeholder='Type a message...'
          />
        </div>
        <div className='text-center mt-6'>
          <button
            className='bg-gray-900 text-white active:bg-gray-700 text-sm font-bold px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-5 ease-linear transition-all duration-150'
            type='submit'
            disabled={submitting}
          >
            {submitting ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
